// Which hosted environment this build is, set at build time by the deploy
// workflow through VITE_APP_ENV. It defaults to production, so a build nobody
// marked can never switch on unreleased work by accident.
//
// Three hosted environments build from three branches: production from `main`,
// staging from `staging`, and dev from `dev`. Staging and dev both talk to a
// Salesforce sandbox and both carry work that is not released yet, so every gate
// that holds something back from production asks PREPROD rather than naming one
// environment. A gate that checked only for staging would switch those features
// off in dev, which is the one place they are meant to be worked on.
//
// PREPROD is also true under the local Vite dev server. It is false for
// production, the public demo, and any value it does not recognise, so a typo
// in a workflow fails closed.
export const APP_ENV = import.meta.env.VITE_APP_ENV || 'production';
export const IS_STAGING = APP_ENV === 'staging';
export const IS_DEV_ENV = APP_ENV === 'dev';
export const PREPROD = Boolean(import.meta.env.DEV) || IS_STAGING || IS_DEV_ENV;

// Work still being built, as opposed to work being tested for release: the
// assessment, the planning team's view, the trade ticket, the planning reports
// and the strategy notes. It lives on dev and the local dev server only.
// Staging is where the next release is tested, by QA, planners and Bird Rock's
// pen test, and it talks to a sandbox holding copies of real client records,
// so it carries only what is headed to production (Jimmy, 2026-10-20). A
// feature moves from DEV_ONLY to PREPROD when it is ready for testing.
export const DEV_ONLY = Boolean(import.meta.env.DEV) || IS_DEV_ENV;
